export default __webpack_public_path__ + "static/media/KZ.T.16.1095.c957dc44.svg";